module.exports = __webpack_public_path__ + "static/media/hotelProv.e520641a.webp";